export enum UserStates {
    Anonymous,
    Implicit,
    Explicit
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/enums/user-states.enum.ts